import { render } from "./OfficialList.vue?vue&type=template&id=6fa3be7c&scoped=true"
import script from "./OfficialList.vue?vue&type=script&lang=js"
export * from "./OfficialList.vue?vue&type=script&lang=js"

import "./OfficialList.vue?vue&type=style&index=0&id=6fa3be7c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6fa3be7c"

export default script